import React from "react";
import { useNavigate } from "react-router-dom";
import { process } from "@progress/kendo-data-query";
import { Layout } from "../components/MasterPage/Layout";
import { AddEditPublicSiteModal } from "../components/Modals/AddEditPublicSiteModal";
import { LoadingPanel } from "../components/LoadingPanel";
import { ConfirmDeleteSiteDialog } from "../components/Modals/ConfirmDeleteSiteDialog";
import { apiRoutes } from "../services/apiRoutes";
import useFetchWithMsal from "../services/useFetchWithMsal";
import { PublicSiteData } from "../Data/PublicSiteData";
import { CustomerPortalGrid } from "../components/Grid/CustomerPortalGrid";
import { ContextMenu } from '../components/ContextMenu';

export const PublicSite = (props) => {
    const gridId_Search = 1;
    const [materialColumns, setmaterialColumns] = React.useState([]);
    const [documentColumns, setdocumentColumns] = React.useState([]);
    const [success, setSuccess] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [siteNameValid, setSiteNameValid] = React.useState(true);
    const [siteUrlValid, setSiteUrlValid] = React.useState(true);
    const [tokenValid, setTokenValid] = React.useState(true);
    const [pending, setPending] = React.useState(false);
    const [showModal, setShowModal] = React.useState(false);
    const [apiTokens, setApiTokens] = React.useState([]);
    const [isData, setIsData] = React.useState(false);
    const [editableCards, setEditableCards] = React.useState([]);
    const [selectedCard, setSelectedCard] = React.useState({});
    const [showConfirmDelete, setShowConfirmDelete] = React.useState(false);
    const [isDuplicate, setIsDuplicate] = React.useState(false);
    const [filterSelected, setfilterSelected] = React.useState(0);
    const [defaultTextSelected, setdefaultTextSelected] = React.useState(0);
    const [filtersDropdownData, setfiltersDropdownData] = React.useState([]);
    const [defaultTextDropdownData, setdefaultTextDropdownData] = React.useState([]);
    const [colorValue, setcolorValue] = React.useState("rgb(0, 97, 98)");
    const [DefaultTextValue, setDefaultTextValue] = React.useState("");
    const [uploadedFile, setUploadedFile] = React.useState(null);
    const [selectedFile, setSelectedFile] = React.useState("");
    const [updateLogo, setUpdateLogo] = React.useState(false);
    const [logoUrl, setlogoUrl] = React.useState(false);
    const [loadingLogo, setloadingLogo] = React.useState(false);
    const [selectedSite, setselectedSite] = React.useState({});
    const [buttonsConfig, setbuttonsConfig] = React.useState([]);
    const [passwordProtected, setpasswordProtected] = React.useState(false);
    const [showContext, setshowContext] = React.useState(false);
    const [downloadGrid, setdownloadGrid] = React.useState(false);
    const [showColumnSelect, setshowColumnSelect] = React.useState(false);
    const imageFileTypes = ["jpg", "jpeg", "pjpeg", "pjp", "jfif", "png", "apng", "gif", "bmp", "ico", "tif", "tiff"];
    const [customerPortals, setcustomerPortals] = React.useState([]);
    const [originalCustomerPortals, setoriginalCustomerPortals] = React.useState([]);
    const [currentCustomerPortalId, setcurrentCustomerPortalId] = React.useState(0);
    const [dataState, setDataState] = React.useState({ skip: 0, take: 25 });
    const [dataResult, setDataResult] = React.useState(process(originalCustomerPortals, dataState));
    const dataStateChange = (event) => {
        setDataResult(process(customerPortals, event.dataState));
        setDataState(event.dataState);
    };

    const offSet = React.useRef({ left: 0, top: 0 });
    const CustomerPortalMenuClick = (CustomerPortalId, e) => {
        setcurrentCustomerPortalId(CustomerPortalId);
        e.preventDefault();
        offSet.current = {
            left: e.clientX,
            top: e.clientY,
        };
        setshowContext(true);
    };

    const menuItems = [props.localizations.OpenPortal, props.localizations.CopyUrl, props.localizations.Edit, props.localizations.Delete];

    const rowContextClick = (e) => {
        const currentEditable = editableCards.find(
            (c) => c.site.id === currentCustomerPortalId
        );
        setSelectedCard(JSON.parse(JSON.stringify(currentEditable.site)));

        if (e.item.text === props.localizations.Delete)
            toggleConfirmDeleteDialog();
        else if (e.item.text === props.localizations.Edit)
            toggleEdit(currentCustomerPortalId);
        else if (e.item.text === props.localizations.CopyUrl)
            handleCopy(currentCustomerPortalId);
        else if (e.item.text === props.localizations.OpenPortal)
            handleOpenSite(currentCustomerPortalId);
    };

    const handleCopy = async (currentCustomerPortalId) => {
        const currentEditableIndex = editableCards.find(
            (c) => c.site.id === currentCustomerPortalId
        );

        let text = `${props.portalBaseDomain}${currentEditableIndex.site.url}`;

        if ("clipboard" in navigator) {
            return await navigator.clipboard.writeText(text);
        } else {
            return document.execCommand("copy", true, text);
        }
    };

    const handleOpenSite = (currentCustomerPortalId) => {
        const currentEditableIndex = editableCards.find(
            (c) => c.site.id === currentCustomerPortalId
        );

        let url = `${props.portalBaseDomain}${currentEditableIndex.site.url}`;

        window.open(
            url,
            "Public Preview",
            "resizable=no, toolbar=no, scrollbars=no, menubar=no, status=no, directories=no"
        );
    };

    const { execute, result } = useFetchWithMsal({
        scopes: props.loginConfig.protectedResources.apiDocumentList.scopes.read,
    });

    const { getData, getCardData, saveSite, listToTree } = PublicSiteData({ execute, localizations: props.localizations, customer: props.customer, languageValue: props.languageValue, colorValue, DefaultTextValue, selectedFile, updateLogo, filterSelected, defaultTextSelected });

    const changeHandler = (event) => {
        let [file] = event.target.files;
        if (file == null)
            return;
        if (file.uid)
            file = file.getRawFile();
        if (file) {
            if (!imageFileTypes.some(x => file.name.indexOf(x) !== -1)) {
                setError(true);
                setErrorMessage(props.localizations.IncorrectFileType);
                return;
            }
            var reader = new FileReader();
            reader.onload = function (readerEvt) {
                setSelectedFile(btoa(readerEvt.target.result));
                setUploadedFile(URL.createObjectURL(file));
                setUpdateLogo(true);
            };
            reader.readAsBinaryString(file);
        }
    };


    const removeLogo = (event) => {
        setUpdateLogo(true);
        setlogoUrl(null);
        setUploadedFile(null);
        setSelectedFile("");
    };

    const handlecolorValueChange = (event) => {
        setcolorValue(event.value);
    };

    const handleDefaultTextValueChange = (event) => {
        setDefaultTextValue(event.html);
    };

    const toggleEdit = (siteId) => {
        setloadingLogo(true);
        let neweditableCards = editableCards;
        const currentEditableIndex = neweditableCards.findIndex(
            (c) => c.site.id === siteId
        );

        setpasswordProtected(neweditableCards[currentEditableIndex].site.passwordProtected);
        setUploadedFile(null);

        const updatedEditable = { ...neweditableCards[currentEditableIndex] };

        const newEditables = [
            ...neweditableCards.slice(0, currentEditableIndex),
            updatedEditable,
            ...neweditableCards.slice(currentEditableIndex + 1),
        ];

        updatedEditable.site.customerPortalPhraseSections = listToTree(updatedEditable.site.customerPortalPhraseSections);
        setEditableCards(newEditables);
        setselectedSite(JSON.parse(JSON.stringify(updatedEditable.site)));
        updatedEditable.site.customerPortalPhraseSections.forEach(x => {
            x.title = x.phraseSection.phraseSectionType.name;
            x.Include = x.include;
            x.PropertyCategoryId = x.phraseSectionTypeId;
        });
        setPhraseSectionCustomer(updatedEditable.site.customerPortalPhraseSections.sort((a, b) => a.sortOrder - b.sortOrder));

        setcolorValue(neweditableCards[currentEditableIndex].site.headerColor);
        setDefaultTextValue(neweditableCards[currentEditableIndex].site.defaultText ?? "");
        let filter = filtersDropdownData.find(x => neweditableCards[currentEditableIndex].site.publicSiteFilters.length > 0 && x.value === neweditableCards[currentEditableIndex].site.publicSiteFilters[0].customerFilterId);
        if (filter == null)
            filter = filtersDropdownData[0];
        setfilterSelected(filter);

        let defaultText = defaultTextDropdownData.find(x => x.value === neweditableCards[currentEditableIndex].site.defaultTextId);
        if (defaultText == null)
            defaultText = defaultTextDropdownData[0];
        setdefaultTextSelected(defaultText);
        toggle(neweditableCards[currentEditableIndex].site.id);
        setSelectedCard(JSON.parse(JSON.stringify(updatedEditable)));

        setlogoUrl(neweditableCards[currentEditableIndex].site.logoUrl);
    };

    let navigate = useNavigate();

    const includecustomcolumn1Change = (columnId, gridId) => {
        if (gridId === gridId_Search) {
            let columns = materialColumns;
            for (var i = 0; i < columns.length; i++) {
                if (columns[i].columnId === columnId) {
                    columns[i].selected = !columns[i].selected;

                    if (columns[i].customerPortalColumns.length === 0)
                        columns[i].customerPortalColumns.push({ CustomerPortalColumnId: 0, customerColumnId: materialColumns[i].customerColumnId });

                    columns[i].customerPortalColumns.selected = columns[i].selected;
                }
            }
            setmaterialColumns(columns);
        }
        else {
            let columns = documentColumns;
            for (var j = 0; j < columns.length; j++) {
                if (columns[j].columnId === columnId) {
                    columns[j].selected = !columns[j].selected;

                    if (columns[j].customerPortalColumns.length === 0)
                        columns[j].customerPortalColumns.push({ CustomerPortalColumnId: 0, customerColumnId: documentColumns[j].customerColumnId });

                    columns[j].customerPortalColumns.selected = columns[j].selected;
                }
            }
            setdocumentColumns(columns);
        }
    };

    const getPageData = async () => {
        try {
            setPending(true);

            let data = await getData();

            setApiTokens(data.options);
            setfiltersDropdownData(data.filters);
            setdefaultTextDropdownData(data.defaultTexts)
            setIsData(data.IsData);
            setEditableCards(data.newEditableCards);
            setcustomerPortals();
            let gridData = data.newEditableCards.map(x => x.site);
            setoriginalCustomerPortals(gridData);
            setcustomerPortals(gridData);
            setDataResult(process(gridData, { skip: 0, take: 25 }));
            setDataState({ skip: 0, take: 25 });
            setPending(false);
        }
        catch (ex){
            setError(true);
            setErrorMessage(props.localizations.RetrieveSiteError);
        }
    };

    const toggle = async (publicSiteId) => {
        setPending(true);
        setloadingLogo(true);
        setUpdateLogo(false);
        setUploadedFile(null);
        setSiteNameValid(true);
        setSiteUrlValid(true);
        setTokenValid(true);
        setShowModal(!showModal);
        setSelectedCard({});
        if (publicSiteId == null || publicSiteId.type === 'click') {
            setIsData(true);
            setPending(false);
            return;
        }

        try {
            let card = await getCardData(publicSiteId);

            setmaterialColumns(card.matColumns.sort((a, b) => a.order - b.order));
            setdocumentColumns(card.docColumns.sort((a, b) => a.order - b.order));
            setlogoUrl(card.newlogoUrl);
            setPending(false);
            setloadingLogo(false);
        }
        catch (ex) {
            setError(true);
            setErrorMessage(props.localizations.RetrieveSiteError);
        }
    };

    const addSiteClick = (e) => {
        // New portals inherit the customer's current Material Header configuration.
        setselectedSite({ name: "", url: "", secondaryHeaderColumnId: props.customer.SecondaryHeaderColumnId ?? null, tertiaryHeaderColumnId: props.customer.TertiaryHeaderColumnId ?? null });
        let sections = [];
        props.customer.PhraseSections.forEach(x => {
            sections.push({
                title: x.PhraseSectionType.Name,
                PhraseSectionTypeId: x.PhraseSectionTypeId,
                Include: true,
                phraseSection: x,
                phraseSectionCustomerPortalId: 0,
                phraseSectionId: x.PhraseSectionId,
                publicPortalId: "00000000-0000-0000-0000-000000000000",
                sortOrder: x.sortOrder
            });
        })
        setPhraseSectionCustomer(sections.sort((a, b) => a.sortOrder - b.sortOrder));
        
        setcolorValue("rgb(0, 97, 98)");
        setDefaultTextValue("");
        setfilterSelected(0);
        setdefaultTextSelected(0);
        setUpdateLogo(false);
        setlogoUrl(null);
        setUploadedFile(null);
        toggle("00000000-0000-0000-0000-000000000000");
    };
    const modalCancelClick = () => { toggle(); };

    const propscheckChange = (phraseSectionTypeId) => {
        PhraseSectionCustomer.forEach(x => {
            if ((x.phraseSection.phraseSectionTypeId != null && x.phraseSection.phraseSectionTypeId === phraseSectionTypeId) || (x.phraseSection.PhraseSectionTypeId != null && x.phraseSection.PhraseSectionTypeId === phraseSectionTypeId))
                x.Include = !x.Include;
        });

        setPhraseSectionCustomer(PhraseSectionCustomer);
    };

    const [PhraseSectionCustomer, setPhraseSectionCustomer] = React.useState(props.customer.PhraseSectionCustomer ?? []);
    const propOnDragOver = event => {
        setPhraseSectionCustomer(event.newState);
    };
    const propOnNavigate = event => {
        setPhraseSectionCustomer(event.newState);
    };

    const validateSite = (e) => {
        if (!e || selectedSite.name != null) {
            setSiteNameValid(Boolean(selectedSite.name));
            const isValidUrl = Boolean(
                new URL(`${props.portalBaseDomain}/${selectedSite.url}`)
            );
            setSiteUrlValid(Boolean(selectedSite.url) && isValidUrl && !isDuplicate);
            setTokenValid(Boolean(selectedSite?.apiToken?.id || selectedSite?.apiToken?.value));

            return Boolean(selectedSite.name) && Boolean(selectedSite.url) && Boolean(selectedSite.apiToken?.id || selectedSite.apiToken?.value);;
        } else {
            setSiteNameValid(Boolean(e.name));
            const isValidUrl = Boolean(
                new URL(`${props.portalBaseDomain}/${e.url}`)
            );
            setSiteUrlValid(Boolean(e.url) && isValidUrl && !isDuplicate);
            setTokenValid(Boolean(e.token?.value));
            
            return Boolean(e.name) && Boolean(e.url) && Boolean(e.token?.value);
        }
    };

    const modalSaveClick = async (e) => {
        try {
            if (!validateSite(e)) {
                setErrorMessage(props.localizations.NotAllFieldsValid);
                setError(true);
                return;
            }

            setPending(true);

            let complete = await saveSite(e, selectedSite, materialColumns, documentColumns, selectedCard, PhraseSectionCustomer);
            if (complete < 0) {
                setError(true);

                switch (complete) {
                    case -1:
                        setErrorMessage(props.localizations.SiteNotCreated);
                        return;
                    case -2:
                        setErrorMessage(props.localizations.SiteExists);
                        return;
                    default:
                        setIsDuplicate(true);
                        return;
                }
            }

            toggle();
            setTimeout(function () {
                setSuccess(false);
            }, 5000);
            setTokenValid(true);
            setSiteUrlValid(true);
            setSiteNameValid(true);
            setSuccess(true);
            setError("");
            setPending(false);
            setIsDuplicate(false);
            getPageData();
        }
        catch (err) {
            setError(err);
            setErrorMessage(err);
            setPending(false);
            setTimeout(() => {
                setError('');
            }, 4000);
        }
    };

    const toggleConfirmDeleteDialog = (event) => { setShowConfirmDelete(!showConfirmDelete); };

    const deleteSite = async (card) => {
        setPending(true);

        await execute("DELETE", apiRoutes.publicSites.delete(card.id));

        setPending(false);
        toggleConfirmDeleteDialog();
        setPending(true);

        await getPageData();
    };

    const [gotData, setgotData] = React.useState(false);
    React.useEffect(() => {
        if (gotData || result == null)
            return;
        setgotData(true);
    }, [execute]);

    React.useEffect(() => {
        if (props.currentTenent.CustomerId == null)
            return;
        if (!props.currentTenent.IsEditCustomerPortalUser)
            navigate("/NoPermissions");
        if (gotData && execute != null)  
            getPageData();
    }, [gotData, execute, props.currentTenent.CustomerId]);

    const handleFilterDropdownChange = (e) => {
        setfilterSelected(e.value);
    };

    const handleDefaultTextDropdownChange = (e) => {
        setdefaultTextSelected(e.value);
    };

    React.useEffect(() => {
        setbuttonsConfig([
            {
                type: 'primary',
                text: props.localizations.AddSite,
                onClick: addSiteClick
            },
            {
                type: 'secondary',
                icon: 'icon-ui-general-libraries',
                tooltip: props.localizations.Columns,
                position: "top",
                onClick: () => { setshowColumnSelect(true); }
            },
            {
                type: 'secondary',
                icon: 'icon-ui-general-download',
                tooltip: props.localizations.Download,
                position: "top",
                onClick: () => { setdownloadGrid(true); }
            }
        ]);
    }, [props.localizations, execute]);

    return (
        <Layout versionNumber={props.versionNumber} currentTenent={props.currentTenent} localizations={props.localizations}
            changeLanguage={props.changeLanguage} languageValue={props.languageValue} success={success} setSuccess={setSuccess} buttonsConfig={buttonsConfig} >

            <CustomerPortalGrid customerPortals={customerPortals} CustomerPortalMenuClick={CustomerPortalMenuClick} handleOpenSite={handleOpenSite} customer={props.customer} dateFormatId={props.customer.dateFormatId} localizations={props.localizations}
                pending={pending} dataState={dataState} dataResult={dataResult} dataStateChange={dataStateChange}
                showColumnSelect={showColumnSelect} downloadGrid={downloadGrid} setdownloadGrid={setdownloadGrid} setshowColumnSelect={setshowColumnSelect} expiredLocalization={props.localizations.Expired}
                noExpiratonLocalization={props.localizations.NoExpiration} tokenExpirationWarning={props.localizations.TokenExpirationWarning } />

            <ContextMenu menuItems={menuItems} offSet={offSet} rowContextClick={rowContextClick} showContext={showContext} setshowContext={setshowContext} />

            {!isData && !pending && (
                <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", marginTop: "4rem" }}>
                    <div className="icon-item text-center">
                        <i className="icon-outline-search"></i>
                        <div className="font-scale-24pt" style={{ width: "120px", textTransform: "capitalize" }}>
                            No Data
                        </div>
                    </div>
                </div>
            )}
            {pending && (
                <LoadingPanel localizations={props.localizations} />
            )}

            <AddEditPublicSiteModal
                toggle={toggle} showModal={showModal} localizations={props.localizations} modalCancelClick={modalCancelClick} modalSaveClick={modalSaveClick}
                siteNameValid={siteNameValid} setSiteNameValid={setSiteNameValid} siteUrlValid={siteUrlValid} setSiteUrlValid={setSiteUrlValid}
                tokenValid={tokenValid} setTokenValid={setTokenValid} apiTokens={apiTokens} loginConfig={props.loginConfig}
                baseDomain={props.portalBaseDomain} isDuplicate={isDuplicate} materialColumns={materialColumns}
                allMaterialColumns={props.customer.columns?.materialColumns ?? []}
                documentColumns={documentColumns} includecustomcolumn1Change={includecustomcolumn1Change} setmaterialColumns={setmaterialColumns}
                setdocumentColumns={setdocumentColumns} selectedSite={selectedSite} setselectedSite={setselectedSite}
                colorValue={colorValue} DefaultTextValue={DefaultTextValue} handlecolorValueChange={handlecolorValueChange}
                handleDefaultTextValueChange={handleDefaultTextValueChange}
                propscheckChange={propscheckChange} propOnDragOver={propOnDragOver} propOnNavigate={propOnNavigate} PhraseSectionCustomer={PhraseSectionCustomer}
                removeLogo={removeLogo} changeHandler={changeHandler} uploadedFile={uploadedFile} logoUrl={logoUrl} loadingLogo={loadingLogo}
                error={error} handleFilterDropdownChange={handleFilterDropdownChange} filtersDropdownData={filtersDropdownData} filterSelected={filterSelected} handleDefaultTextDropdownChange={handleDefaultTextDropdownChange} defaultTextSelected={defaultTextSelected} defaultTextDropdownData={defaultTextDropdownData}
                setError={setError} passwordProtected={passwordProtected} 
                errorMessage={errorMessage}
            />

            {showConfirmDelete && (
                <ConfirmDeleteSiteDialog
                    card={selectedCard}
                    toggleConfirmDeleteDialog={toggleConfirmDeleteDialog}
                    deleteSite={deleteSite}
                    localizations={props.localizations}
                />
            )}
        </Layout>
    );
};
